import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCRechargePhoneValue = class UiCRechargePhoneValue {
    constructor() {
        this.cardSelected = new EventEmitter();
    }
    ngOnInit() { }
    selectedCard(index, item) {
        this.cardIndex = index;
        this.cardSelected.emit(item);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRechargePhoneValue.prototype, "productsData", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRechargePhoneValue.prototype, "cardSelected", void 0);
UiCRechargePhoneValue = __decorate([
    Component({
        selector: 'ui-c-recharge-phone-value',
        template: "<div class=\"recharge-phone-value\" *ngIf=\"productsData\">\n  <ion-row class=\"ion-justify-content-center mb-4\">\n    ({{productsData?.ddd}}) - {{productsData?.phone}} - {{productsData?.operatorDescription}}\n  </ion-row>\n\n  <ion-row *ngIf=\"true\" class=\"ion-justify-content-left\">\n    <ion-col *ngFor=\"let item of productsData?.list; let i = index\" size=\"4\">\n      <ion-card (click)=\"selectedCard(i, item)\" class=\"card-value\" [ngClass]=\"i == cardIndex ? 'card-selected': ''\">\n        <ion-note> {{item.value | currency: 'BRL'}} </ion-note>\n      </ion-card>\n    </ion-col>\n  </ion-row>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCRechargePhoneValue);

let UiCRechargePhoneValueModule = class UiCRechargePhoneValueModule {
};
UiCRechargePhoneValueModule = __decorate([
    NgModule({
        declarations: [UiCRechargePhoneValue],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCRechargePhoneValue]
    })
], UiCRechargePhoneValueModule);

export { UiCRechargePhoneValue, UiCRechargePhoneValueModule };
//# sourceMappingURL=wlp-ui-c-recharge-phone-value.js.map
